import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: { "max-width": "90%", persistent: "" },
      model: {
        value: _vm.visibilidade,
        callback: function ($$v) {
          _vm.visibilidade = $$v
        },
        expression: "visibilidade",
      },
    },
    [
      _c(
        VForm,
        { ref: "form" },
        [
          _c(
            VCard,
            { staticClass: "pa-4" },
            [
              _c(
                VCardTitle,
                [
                  _c(
                    "h2",
                    { staticClass: "headline primary--text text-no-wrap" },
                    [_vm._v(" Importar Mapeamento ")]
                  ),
                  _c(VSpacer),
                  _c(
                    VTooltip,
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                VBtn,
                                _vm._g(
                                  {
                                    attrs: { color: "error", text: "" },
                                    on: { click: _vm.toogle },
                                  },
                                  on
                                ),
                                [
                                  _c(VIcon, { staticClass: "mr-2" }, [
                                    _vm._v(" close "),
                                  ]),
                                  _vm._v(" Fechar "),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("span", [
                        _vm._v("Clique no botão para fechar a janela"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                VCardText,
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c("mapeamento-list", {
                            attrs: {
                              titulo: "ESCOLHA UM MAPEAMENTO FINALIZADO",
                              modo: "IMPORTACAO",
                              mapeamento: _vm.mapeamento,
                            },
                            on: {
                              mapeamento: (value) => (_vm.mapeamento = value),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c("app-title", {
                            attrs: { texto: "ESCOLHA UMA OPÇÃO DE IMPORTAÇÃO" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c("p", { staticClass: "subtitle-1 primary--text" }, [
                            _vm._v(" Mapeamento Comportamental "),
                          ]),
                          _c(
                            VRadioGroup,
                            {
                              model: {
                                value: _vm.tipoImportacaoMapeamento,
                                callback: function ($$v) {
                                  _vm.tipoImportacaoMapeamento = $$v
                                },
                                expression: "tipoImportacaoMapeamento",
                              },
                            },
                            _vm._l(_vm.opcoesImportacao, function (opcao) {
                              return _c(VRadio, {
                                key: opcao.id,
                                attrs: { value: opcao },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c("div", [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(opcao.descricao) + ":"
                                              ),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(opcao.complemento) +
                                                " "
                                            ),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(VCol, { attrs: { cols: "12" } }, [
                        _c("p", { staticClass: "subtitle-1 primary--text" }, [
                          _vm._v(" Mapeamento Técnico "),
                        ]),
                        _c("p", [
                          _vm._v(
                            " Independente da opção de importação selecionada para o mapeamento comportamental, serão importados todos os dados consolidados do mapeamento técnico para a etapa de cadastro. "
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: {
                        disabled:
                          !_vm.mapeamento || !_vm.tipoImportacaoMapeamento,
                        color: "primary",
                      },
                      on: { click: _vm.importar },
                    },
                    [_vm._v(" Importar ")]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", outlined: "" },
                      on: { click: _vm.cancelar },
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }